"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RouteAuthPlugin;
/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-unused-vars */
var React = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var react_router_dom_1 = require("react-router-dom");
var react_error_boundary_1 = require("react-error-boundary");
var react_router_dom_2 = require("react-router-dom");
var hasControllerAccess = function (userRoles, accessRoles) {
    if (userRoles !== undefined && accessRoles !== undefined && accessRoles.length > 0) {
        return userRoles.some(function (role) { return accessRoles.includes(role); });
    }
    return true;
};
var Fallback = function () {
    return (React.createElement("div", null,
        "Unauthorized",
        React.createElement("br", null),
        React.createElement("button", { onClick: function () { return (window.location.href = '/home'); } }, "Go home")));
};
var AuthCheck = function (props) {
    var user = props.user, controllers = props.controllers, children = props.children;
    var location = (0, react_router_dom_2.useLocation)();
    var stores = React.useContext(mobx_react_1.MobXProviderContext);
    React.useEffect(function () {
        var currentController = controllers.find(function (c) { var _a; return (0, react_router_dom_1.matchPath)(location.pathname, { path: c.path, exact: (_a = c.exact) !== null && _a !== void 0 ? _a : true }); });
        if (!currentController) {
            console.warn("No controller found for path: ".concat(location.pathname));
            return;
        }
        var hasAccess = hasControllerAccess(user.partnerRoles, currentController.accessRoles);
        // hacky way of forcing pageId to be reset on client side nav
        try {
            stores['page'].pageId = currentController.pageId;
        }
        catch (e) {
            console.log(e);
        }
        if (!hasAccess) {
            throw new Error('Unauthorized');
        }
    }, [location.pathname]);
    return React.createElement(React.Fragment, null, children);
};
function RouteAuthPlugin(_a) {
    var factories = _a.factories;
    return {
        name: 'route-auth-plugin',
        onBrowserWrapRootElement: function (context, next) {
            var setRootElement = context.setRootElement, getAppData = context.getAppData;
            var stores = getAppData().stores;
            var user = stores.user;
            var page = stores.page;
            var controllers = factories.controllers.map(function (Controller) { return new Controller(); });
            if (typeof window !== 'undefined') {
                var datadogRumObj = window.DD_RUM;
                if (datadogRumObj && user) {
                    datadogRumObj.setUser({
                        sponsoredContentDefault: user.adminContext,
                        sponsoredContentUser: user.sponsoredContentUser,
                        partnerAccountId: user.partnerAccountId,
                    });
                }
            }
            setRootElement(function (RootElement) { return function (props) { return (React.createElement(RootElement, null,
                React.createElement(react_error_boundary_1.ErrorBoundary, { fallback: React.createElement(Fallback, null) },
                    React.createElement(AuthCheck, { user: user, controllers: controllers }, props.children)))); }; });
            return next(context);
        },
    };
}
//# sourceMappingURL=browser.js.map